import React from 'react';
import { Alert } from 'antd';
import PropTypes from 'prop-types';


const AlertMessage = ({ title, message, type, closable }) => (
  <Alert
    message={title}
    description={message}
    type={type}
    closable={closable}
    style={{
      margin: '10px',
      padding: '2px 12px',
    }}
  />
);

AlertMessage.defaualtProps = {
  message: '',
  type: 'success',
  closable: false,
};
AlertMessage.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.any,
  type: PropTypes.string,
  closable: PropTypes.bool,
};

export default AlertMessage;
